// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as MuiCore from '@material-ui/core';
import * as ServiceIcons from '../service/Icons';
import { withStyles } from '@material-ui/core/styles';
import LinkedText from './LinkedText';
import * as serviceActions from '../service/actions';
import * as Formatters from './Formatters';

const styles = theme => ({
    /* Raised box around the content */
    contentBox : {
      width: '100%',
      height: '100%',
      borderRadius: 20,
      padding: 0,
      display: 'flex',
    },
    
    /* Scrolled area inset from the content box */
    contentScroller : {
      overflow: 'auto',
      width: '100%',
    },
  
    /* Top control area with search box and add content */
    controlPanel : {
      display: 'flex',    
      alignItems: 'center',
    },
  
    /* Search input in the control panel */
    searchInput : {
      fontSize: 12,
      height: 30,
    },
    
  
    /* Contact list container */
    contactList : {
      marginRight: 20,
    },
  
    /* Contact row */
    contactRow: {
      display: 'flex',
      marginRight: 30,
    },
  
    /* Left side icon */
    peopleIcon : {
      marginLeft: 20,
      display: 'flex',
      alignItems: 'center',
    },
  
    /* Clickable center area with contact name */
    infoBlock : {
      flexGrow: '1',
      paddingLeft: 10,
      '&:hover' : {
        background: theme.palette.grey[200],
      },
    },
  
    /* Top name line in the info block */
    name: {
      ...theme.typography.body1,
      fontWeight: 'bold',
    },
    /* Bottom business name line in the info block */
    business: {
      ...theme.typography.body1,
      color: theme.palette.primary.main,
    },
    
  
    /* Right side menu */
    menuBlock : {
      display: 'flex',
      alignItems: 'center',
    },
  
    /* Section row at the start of each letter */
    sectionRow: {
      marginLeft: 20,
      marginRight: 20,
      marginTop: 20,   
      ...theme.typography.body2,
      fontWeight: 'bold',
    },
  
    oddRow: {
      
    },
  
    evenRow: {
      backgroundColor: '#fcf9f2',
  
    },
    tableHeader:{
      backgroundColor:'#a9a1b6'
    },
    tableHeaderCell:{
      color:'white',
      fontFamily:'Sofia-bold',
      backgroundColor:'#a9a1b6'
    }
  });

class RubyTable extends Component {
    
    state = {
        contactMenuOpen : false,
        contactMenuElement : null,
        menuContact : {},
        confirmDelete : false,
    }

    openMenu = (event, contact) => {
        this.setState({contactMenuElement : event.currentTarget,
                        contactMenuOpen : true,
                        menuContact : contact });
    }

    render() {
        const {columns, tableData, actions, classes, tableClass, stickyHeader, size} = this.props;
        return(
            <React.Fragment className={classes.contactList}>
                {/* <MuiCore.Menu anchorEl={this.state.contactMenuElement}
                            onClose={() => this.setState({contactMenuOpen: false})}
                            transformOrigin={{
                                horizontal : 'right',
                                vertical: 'top',
                            }}
                            open={this.state.contactMenuOpen}>
                {actions.map(action => {<MuiCore.MenuItem onClick={action.click}>
                    {action.name}
                </MuiCore.MenuItem>})}
                </MuiCore.Menu> */}
                <MuiCore.TableContainer component={MuiCore.Paper} style={{marginTop: 30}} className={tableClass}>
                    <MuiCore.Table sx={{minWidth: 700}} stickyHeader={stickyHeader} size={size}>
                    <MuiCore.TableHead>
                        <MuiCore.TableRow className={classes.tableHeader}>
                            {columns.map((item) => {
                                return(
                                <MuiCore.TableCell className={classes.tableHeaderCell}>{item.heading}</MuiCore.TableCell>
                                )
                            })}
                            {/* <MuiCore.TableCell className={classes.tableHeaderCell}>Name</MuiCore.TableCell>
                            <MuiCore.TableCell className={classes.tableHeaderCell}>Business</MuiCore.TableCell>
                            <MuiCore.TableCell className={classes.tableHeaderCell}>Phone</MuiCore.TableCell>
                            <MuiCore.TableCell className={classes.tableHeaderCell}>Email</MuiCore.TableCell> */}
                        </MuiCore.TableRow>
                    </MuiCore.TableHead>
                    <MuiCore.TableBody>
                        {tableData !== undefined && tableData.map((contact, index) => {

                        return(
                            <MuiCore.TableRow 
                            key={index}
                            hover
                            className={index%2 === 0 ? classes.evenRow : classes.oddRow}
                            >
                                {columns.map(column => {
                                    if(typeof(column.calculated) === 'function'){
                                      return(column.calculated(contact))
                                    }
                                    if(column.formatter === 'mobile'){
                                        return(
                                            <MuiCore.TableCell>
                                                <LinkedText value={Formatters.formatPhoneNumber(contact[column.key])} onClick={this.props.openContactLink}/>
                                            </MuiCore.TableCell>
                                        )
                                    }
                                    if(column.formatter === 'email'){
                                        return(
                                            <MuiCore.TableCell>
                                                <LinkedText value={Formatters.formatPhoneNumber(contact[column.key])} onClick={this.props.openContactLink}/>
                                            </MuiCore.TableCell>
                                        )
                                    }
                                    if(column.formatter === 'date'){
                                      return(<MuiCore.TableCell>{Formatters.formatDate(contact[column.key])}</MuiCore.TableCell>)
                                    }
                                    if(column.formatter === 'time'){
                                      return(<MuiCore.TableCell>{Formatters.formatTime(contact[column.key])}</MuiCore.TableCell>)
                                    }
                                    return(
                                        <MuiCore.TableCell style={{fontFamily:'Sofia'}}>{contact[column.key]}</MuiCore.TableCell>
                                    )
                                })}
                            {/* <MuiCore.TableCell component="th" scope="row">{contact.displayName}</MuiCore.TableCell>
                            <MuiCore.TableCell>{contact.business}</MuiCore.TableCell>
                            <MuiCore.TableCell>{(contact.contactMethods || [])
                                                .filter(method=>method.contactMethodType==='PHONE')
                                                .map(item => 
                                                    <div>
                                                    <LinkedText value={Formatters.formatPhoneNumber(item.phoneNumber)} onClick={this.props.openContactLink}/>
                                                    {item.phoneExtension !== undefined ? ` ext. ${item.phoneExtension}` : ''}
                                                    </div>
                                                )}</MuiCore.TableCell>
                            <MuiCore.TableCell>{(contact.contactMethods || [])
                                                .filter(method=>method.contactMethodType==='EMAIL')
                                                .map(item => 
                                                    <div>
                                                    <LinkedText value={item.email} onClick={this.props.openContactLink}/>
                                                    </div>
                                                )}</MuiCore.TableCell>
                            <MuiCore.TableCell align='right'>
                                <div className={classes.menuBlock}>
                                <MuiCore.IconButton
                                    size='small'
                                    onClick={(event) => {
                                    this.openMenu(event, contact);
                                    event.stopPropagation();
                                    }}>
                                    <ServiceIcons.MenuIcon/>
                                </MuiCore.IconButton>
                                </div>
                            </MuiCore.TableCell> */}
                            </MuiCore.TableRow>
                        )})}
                        {actions !== undefined && actions.length !== 0 && 
                                    <MuiCore.TableCell align='right'>
                                    <div className={classes.menuBlock}>
                                    <MuiCore.IconButton
                                        size='small'
                                        onClick={(event) => {
                                        event.stopPropagation();
                                        }}>
                                        <ServiceIcons.MenuIcon/>
                                    </MuiCore.IconButton>
                                    </div>
                                </MuiCore.TableCell>
                                }
                    </MuiCore.TableBody>
                    </MuiCore.Table>
                </MuiCore.TableContainer>
            </React.Fragment>
        )
    }
}

RubyTable.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.object).isRequired,
    tableData: PropTypes.arrayOf(PropTypes.object).isRequired,
    actions: PropTypes.arrayOf(PropTypes.object),
    tableClass: PropTypes.object,
    stickyHeader: PropTypes.bool,
    size: PropTypes.string
}

RubyTable.defaultProps = {
  columns: [],
  tableData: [],
  actions: [],
  tableClass: {},
  stickyHeader: false,
  size: 'medium'
}

const mapStateToProps = (state) => {
    return ({
      
    });
  };
  
  const mapDispatchToProps = {
    openContactLink : serviceActions.openContactLink,
  };

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RubyTable));